import React from 'react';
import { range } from 'lodash';
import Skeleton from '@mui/material/Skeleton';
import { Stack } from '@mui/material';

const AvailabilityCalendarSkeleton = () => (
  <Stack
    direction="row"
    justifyContent="space-between"
    flexWrap="wrap"
    height={191}
  >
    <Skeleton width={20} height={32} />
    {range(1, 6).map(k => (
      <Stack key={k}>
        <Skeleton width={48} height={32} />
        <Skeleton width={48} height={120} />
      </Stack>
    ))}
    <Skeleton width={20} height={32} />
    <Skeleton sx={{ mx: 'auto' }} width="60%" height={25} />
  </Stack>
);

export default AvailabilityCalendarSkeleton;
